module.exports = __webpack_public_path__ + "static/media/KatnissEverdeen.1054e431.png";